import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import styled, {css} from 'styled-components'

export const StyledAslDistrictTrigger = styled(Flexbox)`
    white-space: nowrap;
    overflow: hidden;
`

export const StyledSelectItemAslDistrict = styled.span(
    ({theme: {palette}}) => css`
        color: ${palette.neutral[600]};
        text-overflow: ellipsis;
        overflow: hidden;
    `
)

export const StyledDistrict = styled.p(
    ({theme: {typography}}) => css`
        ${typography.textSm};
    `
)
